import { useEffect, useId, useRef, useState } from 'react';
import { problemContactLinks } from '../landingContact';
import './ProblemReport.css';
import SupportRequests, { supportFetch } from './SupportRequests';

export default function ProblemReport({ section = 'App', session }) {
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [busy,setBusy]=useState(false),[error,setError]=useState(''),[sent,setSent]=useState(null),[history,setHistory]=useState(false);
  const attempt=useRef(null);
  const sending=useRef(false);
  const id = useId();
  const trigger = useRef(null);
  const input = useRef(null);
  const links = problemContactLinks(section, description);
  useEffect(() => { if (open) input.current?.focus(); }, [open]);
  function close() { setOpen(false); trigger.current?.focus(); }
  async function send() {
    if(sending.current)return;
    sending.current=true;setBusy(true);setError('');
    try {
      if(!attempt.current) attempt.current={requestKey:crypto.randomUUID(),section,description:description.trim()};
      const result=await supportFetch(session,'create',attempt.current);
      if(!result.request?.id)throw new Error('Salvataggio non confermato');
      setSent(result.request.id);setDescription('');attempt.current=null;
    } catch(e){setError(e.message);}finally{setBusy(false);sending.current=false;}
  }
  return <div className="problem-report">
    <button type="button" className="auth-forgot problem-report-trigger" ref={trigger} aria-expanded={open} aria-controls={id} onClick={() => setOpen(!open)}>Segnala un problema</button>
    {open && <section id={id} className="problem-report-panel app-card glass-card" aria-label="Segnala un problema" onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); close(); } }}>
      <label htmlFor={`${id}-description`}>Cosa non funziona?</label>
      <textarea id={`${id}-description`} ref={input} maxLength={1200} rows={3} value={description} disabled={busy || Boolean(attempt.current)} onChange={event => {setDescription(event.target.value);setSent(null);}} placeholder="Cosa stavi facendo e cosa è successo?" aria-describedby={`${id}-privacy`} />
      <p id={`${id}-privacy`}>Non inserire password o dati dei clienti. Per uno screenshot, usa email o WhatsApp oscurando i dati personali.</p>
      <div className="problem-report-actions">
        {session && <button type="button" className="button button-small" disabled={busy || description.trim().length<5} onClick={send}>{busy?'Invio…':attempt.current?'Riprova lo stesso invio':'Invia segnalazione'}</button>}
        {description.trim() && <>
          {links.whatsapp && <a className="button button-small" href={links.whatsapp.href} target="_blank" rel="noreferrer">Apri WhatsApp</a>}
          {links.email && <a className="button button-small button-ghost" href={links.email.href}>Apri email</a>}
        </>}
        <button type="button" className="button button-small button-ghost" onClick={close}>Chiudi</button>
      </div>
      {sent&&<p role="status">Segnalazione #{sent.slice(0,8)} ricevuta. Puoi seguirla qui in “Le tue segnalazioni”.</p>}
      {error&&<p role="alert">{error} {attempt.current&&'Riprova lo stesso invio: non creerà un duplicato.'}</p>}
      {session&&<><button className="auth-forgot" type="button" onClick={()=>setHistory(v=>!v)} aria-expanded={history}>Le tue segnalazioni</button>{history&&<SupportRequests session={session} revision={sent}/>}</>}
      {description.trim() && <p>Se scegli email o WhatsApp, premi Invia anche nell’app scelta.</p>}
    </section>}
  </div>;
}
